export default "__VITE_ASSET__D7wcM9TE__"